import React from 'react'
import { Link } from 'react-router-dom'
import { ConvertToCloudFrontUrl } from '../../utils/ConvertToCloudFrontUrl'
export default function CardSubUser(props) {
    const profileUrl = '/user/' + props.idUser

    return (
        <div className='col-12 col-sm-6 col-lg-4 col-xl-3 p-2'>
            <div className='cardShowUser sub-user-card h-100 p-3 d-flex'>
                <Link to={profileUrl}>
                    <img
                        className='showListUser sub-user-avatar'
                        src={ConvertToCloudFrontUrl(props.avatarUser)}
                        alt={'ảnh đại diện của người dùng ' + props.username}
                    />
                </Link>

                <div className='d-flex flex-column ms-3 decorationLink sub-user-content'>
                    <Link to={profileUrl}>
                        <h5 className='nameUserInLink'>{props.username}</h5>
                    </Link>
                    <p className=' about-user-clamp'>{props.about}</p>
                    <div className='d-flex align-items-center'>
                        <p className='me-1 mb-0'>
                            {props.intUserSub}
                        </p>
                        <div>•</div>
                        <p className='ms-1 mb-0'>
                            Người đăng ký
                        </p>
                    </div>
                </div>
            </div>
        </div>

    )
}
